import React, { FC, useState, useRef, useMemo } from 'react'

import { useSelector, useDispatch } from '../../store/index'
import { chooseProjectAction } from '../../store/project/slice'

import { push } from 'connected-react-router'
import { AUTH_ROUTE } from '../../pages/App/routes'
import { generatePath } from 'react-router-dom'

import { TProject } from '../../store/project/types'

import { PopupActions } from 'reactjs-popup/dist/types'
import CustomPopup from '../UI/Popup'

import './SearchByProjects.scss'
import { setUserRoleAction } from '../../store/auth/slice'

const offsetX = -48
const offsetY = 1

interface SearchByProjectsProps {}

const SearchByProjects: FC<SearchByProjectsProps> = () => {
  const { projects } = useSelector(({ agency: { projects } }) => ({ projects }))

  const dispatch = useDispatch()

  const popupRef = useRef<PopupActions>()

  const [searchQuery, setSearchQuery] = useState<string>('')

  const resultByQuery = useMemo(() => {
    if (searchQuery.length) {
      return projects.filter(({ name }) =>
        name.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase())
      )
    } else {
      return []
    }
  }, [searchQuery, projects])

  const changeProject = (project: TProject) => {
    dispatch(setUserRoleAction(project.role))
    dispatch(chooseProjectAction(project))
    closeModal()
    dispatch(
      push(
        generatePath(AUTH_ROUTE.CALENDAR, {
          projectId: project.id
        })
      )
    )
  }

  const closeModal = () => {
    setSearchQuery('')
    popupRef?.current?.close()
  }

  return (
    <CustomPopup
      customRefProp={popupRef}
      className='projects-search'
      position='right center'
      trigger={() => <div className='project-navigation__search__icon'></div>}
      onClose={closeModal}
      arrow={false}
      offsetX={offsetX}
      offsetY={offsetY}
    >
      <div className='projects-search-popup'>
        <div className='projects-search-popup_input'>
          <div className='projects-search-popup-search'></div>
          <div className='projects-search-popup_project-name'>
            <input
              placeholder='I’m looking for project...'
              className='projects-search-popup_project-name-input'
              value={searchQuery}
              onChange={({ currentTarget: { value } }: React.ChangeEvent<HTMLInputElement>) =>
                setSearchQuery(value)
              }
            />
          </div>
          <div className='projects-search-popup_clear'>
            <button
              className='projects-search-popup_clear-button'
              onClick={() => setSearchQuery('')}
            >
              Clear
            </button>
          </div>
        </div>
        {!!resultByQuery.length && !!searchQuery.length && (
          <div className='projects-search-popup_result'>
            <div className='projects-search-popup_result-title'>Results</div>
            <div className='projects-search-popup_result-list'>
              {resultByQuery.map(({ name, logo_image_link: logoImageLink, id }, index) => (
                <div
                  key={id}
                  className='projects-search-popup_result-list-item'
                  onClick={() => changeProject(resultByQuery[index])}
                >
                  <div className='projects-search-popup_result-list-item-logo'>
                    <img src={logoImageLink!} alt='' />
                  </div>
                  <div className='projects-search-popup_result-list-item-name'>{name}</div>
                </div>
              ))}
            </div>
          </div>
        )}
        {!resultByQuery.length && !!searchQuery.length && (
          <div className='projects-search-popup_result_empty'>Empty result</div>
        )}
      </div>
    </CustomPopup>
  )
}

export default SearchByProjects
